const normalizeValue = (value: unknown): string | null => {
  if (Array.isArray(value)) value = value[0];
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length ? trimmed : null;
};

const getUtmCookieOptions = () => {
  const runtimeConfig = useRuntimeConfig();
  return {
    maxAge: runtimeConfig.public.utmParameterCookieMaxAge,
    secure: !process.dev,
    httpOnly: true,
    sameSite: 'strict' as const,
  };
};

export default defineNuxtRouteMiddleware(async (to) => {
  const params: Record<string, string> = {};
  for (const [key, rawValue] of Object.entries(to.query)) {
    if (!key.toLowerCase().startsWith('utm_')) continue;
    const value = normalizeValue(rawValue);
    if (value) params[key] = value;
  }

  if (!Object.keys(params).length) return;


  const { value } = await $fetch<{ value?: string }>('/api/persist-cookie', {
    method: 'GET',
    query: { key: 'utm_parameters' },
  }).catch(() => ({ value: '{}' }));

  let existing: Record<string, string> = {};
  try {
    existing = JSON.parse(value || '{}') as Record<string, string>;
  } catch {
    existing = {};
  }

  await $fetch('/api/persist-cookie', {
    method: 'POST',
    body: {
      key: 'utm_parameters',
      value: JSON.stringify({ ...existing, ...params }),
      options: getUtmCookieOptions(),
    },
  });
});
